export function getPropertyValuationApi(path: string) {
  return `${import.meta.env.VUE_APP_PROPERTY_VALUATION_API}${path}`;
}

export function getLeadDistributionApi(path: string) {
  return `${import.meta.env.VUE_APP_SELLER_LEAD_INGESTIONS_API_BASE_URL}${path}`;
}

export function getSellerLeadsApi(path: string) {
  return `${import.meta.env.VUE_APP_SELLER_LEAD_MANAGEMENT_API_BASE_URL}${path}`;
}

export function getHomeOwnerWorldApi(path: string) {
  return `${import.meta.env.VUE_APP_HOME_OWNER_WORLD_API}${path}`;
}
